import type { ResignationRequestFormValues } from './types';

export const initialFormValues: ResignationRequestFormValues = {
  resignationDate: '',
  approxSettlementAmount: '',
  lastWorkingDate: '',
  letterOfContent: '',
  reason: null,
};
